import { IoChevronDownSharp } from "react-icons/io5";
import { Link } from "react-scroll";

import { useEffect, useMemo, useRef, useState } from "react";
import { format } from "date-fns";
import { GuestsPopup } from "../component/GuestsPopup";
import { Clock } from "lucide-react";
import CheckInModal from "../component/CheckDateModal";
import CheckOutModal from "../component/CheckOut";
import CheckDateModal from "../component/CheckDateModal";
import toast from "react-hot-toast";
import BuildingIcon from "../component/BuildingIcon";
import BuildingAltIcon from "../component/BuildingAltIcon";
import { FaChevronDown } from "react-icons/fa";
import DateRangePicker from "../component/DateRangePicker";
import { Minus, Plus } from "lucide-react";
import { BiDownArrow } from "react-icons/bi";
import { BookingFormPopup } from "../component/BookingFormPopup";
import EventDateTimePicker from "../component/EventDateTimePicker";

const eventOptions = [
  "Wedding",
  "Birthday Party",
  "Anniversary Celebration",
  "Engagement Party",
  "Baby Shower",
  "Graduation Party",
  "Corporate Meeting",
  "Conference",
  "Workshop",
  "Seminar",
  "Product Launch",
  "Networking Event",
  "Charity Event",
  "Awards Ceremony",
  "Retirement Party",
  "Farewell Party",
  "Team Building Event",
  "Holiday Party",
  "Cocktail Party",
  "Reunion",
  "Music Concert",
  "Exhibition",
  "Trade Show",
  "Festival",
  "Religious Ceremony",
  "Community Event",
  "Fundraiser",
];

const Home = () => {
  const roomsList = ["Rooms", "Event Hall"];
  const hallsList = ["Main Event Hall", "Banquet Hall", "Conference Hall"];
  const [active, setActive] = useState("rooms");
  const [selectedType, setSelectedType] = useState("");
  const options = ["Room 1", "Room 2", "Room 3"];
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingData, setBookingData] = useState(null);
  const [eventDateTime, setEventDateTime] = useState(null);

  const [children, setChildren] = useState(0);
  const [guestOpen, setGuestOpen] = useState(false);
  const [checkInOpen, setCheckInOpen] = useState(false);
  const [checkin, setCheckin] = useState(undefined);
  const [checkOutOpen, setCheckOutOpen] = useState(false);

  const [checkout, setCheckout] = useState(undefined);
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState(null);

  const wrapRef = useRef(null);
  const [dates, setDates] = useState({
    checkin: undefined,
    checkout: undefined,
  });

  const handleSubmit = () => {
    // Validation
    if (!selectedType) return toast.error("Please select Room/Hall type");
    if (!range?.from && active === "rooms")
      return toast.error("Please select Check-in date");
    if (!range?.to && active === "rooms")
      return toast.error("Please select Check-out date");
    if (!selectedRoom && active === "rooms")
      return toast.error("Please select Rooms count");
    if (!guests && active === "hall")
      return toast.error("Please enter number of Guests");

    const formatDate = (date) =>
      date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    const data = {
      "Room/Hall Type": selectedType,
      ...(active === "rooms" && { "Check In": formatDate(range.from) }),
      ...(active === "rooms" && { "Check Out": formatDate(range.to) }),
      ...(active === "rooms" && { Rooms: selectedRoom }),
      Guests: active === "rooms" ? guestValue : guests,
      ...(active === "hall" && { "Event Name": eventName }),
      ...(active === "hall" && {
        "Event Date": eventDate ? formatDate(new Date(eventDate)) : "--/--/--",
      }),
      ...(active === "hall" && {
        "Event Time": eventDate
          ? format(new Date(eventDate), "HH:mm")
          : "HH:mm",
      }),
    };

    // store and show popup
    setBookingData(data);
    setShowBookingForm(true);
  };

  // const handleSubmit = () => {
  //   if (!selectedType) return toast.error("Please select Room/Hall type");
  //   if (!range?.from) return toast.error("Please select Check-in date");
  //   if (!range?.to) return toast.error("Please select Check-out date");
  //   if (!selectedRoom) return toast.error("Please select Rooms count");
  //   if (!guestValue) return toast.error("Please select Guests");

  //   const formatDate = (date) =>
  //     date.toLocaleDateString("en-GB", {
  //       day: "2-digit",
  //       month: "short",
  //       year: "numeric",
  //     });

  //   const data = {
  //     "Room/Hall Type": selectedType,
  //     "Check In": formatDate(range.from),
  //     "Check Out": formatDate(range.to),
  //     Rooms: selectedRoom,
  //     Guests: guestValue,
  //     ...(active === "hall" && { "Event Name": eventName }),
  //   };

  //   setBookingData(data); // store for popup
  //   setShowBookingForm(true); // open popup
  // };

  const fmt = (d) =>
    d
      ? d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "Select date";

  useEffect(() => {
    const onDown = (e) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) setGuestOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const rooms = ["01", "02", "03", "04"];

  const [adults, setAdults] = useState(0);
  const [kids, setKids] = useState(0);
  const [selectedRoom, setSelectedRoom] = useState(1);
  const [foodType, setFoodType] = useState("");
  const [dateOpen, setDateOpen] = useState(false);
  const [dateEventOpen, setEventDateOpen] = useState(false);
  const [guests, setGuests] = useState(1);

  /*   const guestValue = useMemo(() => {
    const total = adults + kids;
    return `${total} Guest${total > 1 ? "s" : ""} • ${adults} Adult${adults > 1 ? "s" : ""}${kids ? ` • ${kids} Child${kids > 1 ? "ren" : ""}` : ""}`;
  }, [adults, kids]); */

  const guestValue = `${adults} Adult${adults > 1 ? "s" : ""} · ${kids} Child${kids !== 1 ? "ren" : ""}`;

  const handleDone = () => {
    localStorage.setItem("guests", JSON.stringify({ adults, kids }));
    setGuestOpen(false);
  };

  const [range, setRange] = useState({ from: null, to: null });
  const [openType, setOpenType] = useState(null);

  const checkinText = useMemo(() => {
    return range?.from ? format(range.from, "MMM d, yyyy") : "--/--/----";
  }, [range?.from]);

  const checkoutText = useMemo(() => {
    return range?.to ? format(range.to, "MMM d, yyyy") : "--/--/----";
  }, [range?.to]);

  const openPicker = (type) => {
    setOpenType(type);
    setDateOpen(true);
  };

  const closePicker = () => {
    setDateOpen(false);
    setEventDateOpen(false);
  };

  return (
    <div className="  w-screen  ">
      <section className="relative w-full h-screen md:h-[95vh] ">
        <img
          src="/assets/home.svg"
          alt="home"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="w-full px-5 md:px-20 absolute bottom-10 md:bottom-0">
          <div className="mx-auto w-full relative">
            <div className="flex justify-center px-6 py-4  absolute -top-14 left-1/2 -translate-x-1/2 z-20">
              <div className="flex w-full justify-center items-center h-[70px] font-bold font-creto rounded-full bg-black/30 backdrop-blur-sm px-6 p-6 md:py-4">
                <button
                  onClick={() => setActive("rooms")}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-all duration-300
                      ${active === "rooms" ? "bg-white text-[#1F2226] shadow" : "text-white"}`}
                >
                  <BuildingIcon
                    size={16}
                    color={active === "rooms" ? "black" : "white"}
                  />
                  Rooms
                </button>

                <button
                  onClick={() => setActive("hall")}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-all duration-300 text-nowrap
                  ${active === "hall" ? "bg-white text-[#1F2226] shadow" : "text-white"}`}
                >
                  <BuildingAltIcon
                    size={20}
                    className={active === "hall" ? "black" : "white"}
                  />
                  Event Hall
                </button>
              </div>
            </div>
            <div className=" border-[0.5px]  border-[#C3C3C385] backdrop-blur-[8px]  bg-black/[14%]  ">
              <div className="mt-8 md:mb-0 md:mt-4 grid grid-cols-2 md:grid-cols-6 text-center items-center gap-4 md:h-[122px] p-4">
                <GlassFieldDropdown
                  label={active === "hall" ? "Hall Type" : "Room Type"}
                  options={active === "hall" ? hallsList : roomsList}
                  selected={selectedType}
                  setSelected={setSelectedType}
                  className="md:border-r"
                />
                {/* Event Name Input - Only show for Event Hall */}
                {active === "hall" && (
                  <div className="relative">
                    <GlassFieldDropdown
                      label="Event Name"
                      options={eventOptions}
                      selected={eventName}
                      setSelected={setEventName}
                      className="md:border-r"
                    />
                  </div>
                )}

                {/*     <GlassFieldDropdown
                  label="Check In"
                  value={checkinText}
                  className="border-r-2"
                  onClick={() => setOpenType("checkin")}
                />

                <GlassFieldDropdown
                  label="Check Out"
                  value={checkoutText}
                  className="border-r-2"
                  onClick={() => {
                    if (!range?.from) return setOpenType("checkin");
                    setOpenType("checkout");
                  }}
                /> */}

                {active === "rooms" && (
                  <>
                    <GlassFieldDropdown
                      label="Check In"
                      value={checkinText}
                      className="md:border-r"
                      onClick={() => openPicker("checkin")}
                    />

                    <GlassFieldDropdown
                      label="Check Out"
                      value={checkoutText}
                      className="md:border-r"
                      onClick={() => {
                        if (!range?.from) return openPicker("checkin"); // force checkin first
                        openPicker("checkout");
                      }}
                    />
                  </>
                )}
                {/*   <div>
                  <label className="text-[20px] md:text-[24px] font-creto font-bold text-white cursor-pointer">
                    Rooms
                  </label>
                  <select
                    value={selectedRoom}
                    onChange={(e) => setSelectedRoom(e.target.value)}
                    className="w-full   bg-white/2 backdrop-blur-[3px] px-3 py-1.5 text-black"
                  >
                    {rooms?.map((room) => (
                      <option key={room} value={room}  className=" text-black">
                        {room}
                      </option>
                    ))}
                  </select>
                </div> */}
                {active === "hall" && (
                  <>
                    <div
                      className="relative md:border-r  cursor-pointer"
                      onClick={() => setEventDateOpen(true)}
                    >
                      <label className="block text-[14px] md:text-[24px] font-creto font-bold text-white mb-2">
                        Event Date
                      </label>

                      <input
                        readOnly
                        value={
                          eventDate
                            ? new Date(eventDate).toLocaleDateString("en-GB")
                            : "--/--/--"
                        }
                        className="
          w-full bg-transparent text-white
          px-3 py-2 text-[14px]
          md:text-[16px] font-creto font-normal
          text-center cursor-pointer
          outline-none border-none
        "
                      />
                    </div>
                    <div
                      className="relative md:border-r cursor-pointer"
                      onClick={() => setEventDateOpen(true)}
                    >
                      <label className="block text-[14px] md:text-[24px] font-creto font-bold text-white mb-2">
                        Event Time
                      </label>

                      <div className="flex items-center justify-center gap-2">
                        <Clock size={16} className="text-gray-400" />
                        <input
                          readOnly
                          value={
                            eventDate
                              ? format(new Date(eventDate), "HH:mm")
                              : "HH:mm"
                          }
                          className="
          w-full bg-transparent text-white
          px-3 py-2 text-[14px]
          md:text-[16px] font-creto font-normal
          text-center cursor-pointer
          outline-none border-none
        "
                        />
                      </div>
                    </div>
                  </>
                )}

                {active === "rooms" && (
                  <div className="relative md:border-r border-white">
                    <label className="block text-[14px] md:text-[24px] font-creto font-bold text-white mb-2">
                      Rooms
                    </label>

                    <div className="flex items-center justify-between rounded-lg px-4 py-2">
                      {/* Minus Button */}
                      <button
                        onClick={() =>
                          setSelectedRoom((prev) => (prev > 1 ? prev - 1 : 1))
                        }
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/30 text-white text-lg font-bold transition"
                      >
                        <Minus />
                      </button>

                      {/* Room Count */}
                      <span className="text-white text-lg font-semibold">
                        {selectedRoom}
                      </span>

                      {/* Plus Button */}
                      <button
                        onClick={() => setSelectedRoom((prev) => prev + 1)}
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/30 text-white text-lg font-bold transition"
                      >
                        <Plus />
                      </button>
                    </div>
                  </div>
                )}

                {active !== "hall" && (
                  <div className="relative md:col-span-1 col-span-2">
                    <button
                      type="button"
                      onClick={() => setGuestOpen(true)}
                      className=""
                    >
                      <div
                        onClick={() => setGuestOpen(true)}
                        className="w-full pointer-events-none"
                      >
                        <GlassFieldDropdown label="Guests" value={guestValue} />
                      </div>
                      {/* <div className="pointer-events-none">
                      <GlassFieldDropdown label="Guests" value={guestValue} />
                    </div> */}
                    </button>
                  </div>
                )}
                {active === "hall" && (
                  <div className="relative">
                    <label className="block text-[14px] md:text-[24px] font-creto font-bold text-white">
                      Food Type
                    </label>

                    <select
                      value={foodType}
                      onChange={(e) => setFoodType(e.target.value)}
                      className="
        w-full bg-white/10 text-white px-3 py-2 text-center
        text-[14px] md:text-[16px] font-creto font-normal
        rounded-md outline-none focus:ring-0
      "
                    >
                      <option value="" disabled>
                        Select Food Type
                      </option>
                      <option value="veg" className="text-black">
                        Veg
                      </option>
                      <option value="non-veg" className="text-black">
                        Non-Veg
                      </option>
                    </select>
                  </div>
                )}

                <div
                  className={`${active !== "hall" && " md:col-span-1 col-span-2 "}  md:mb-0`}
                >
                  <button
                    type="button"
                    className="
        h-[44px]
        px-6
       
        text-white
        text-sm
        font-semibold
        whitespace-nowrap
        bg-[linear-gradient(97.63deg,#2573AE_0.84%,#0B3D63_95.13%)]
        shadow
        hover:opacity-90
        transition"
                    onClick={handleSubmit}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {guestOpen && (
        <GuestsPopup
          adults={adults}
          setAdults={setAdults}
          kids={kids}
          setKids={setKids}
          onClose={handleDone}
        />
      )}

      {dateOpen && (
        <div className=" fixed bg-black/50 w-full flex justify-center items-end md:items-center inset-0 z-50">
          <DateRangePicker
            range={range}
            onRangeSelect={setRange}
            onClose={closePicker}
          />
        </div>
      )}
      {showBookingForm && bookingData && (
        <BookingFormPopup
          bookingData={bookingData}
          onClose={() => {
            setShowBookingForm(false);
            setRange({ from: null, to: null });
            setSelectedType("Executive Room");
            setSelectedRoom(1);
            setAdults(1);
            setChildren(0);
            setSelectedRoom(1);
            setAdults(1);
            setKids(0);
            setGuests(1);
            setEventName("");
            setEventDate(null);
            setRange({ from: null, to: null });
            setSelectedType(
              active === "rooms" ? "Executive Room" : hallsList[0],
            );
          }}
        />
      )}
      {dateEventOpen && active === "hall" && (
        <div className="fixed bg-black/50 w-full flex justify-center items-end md:items-center inset-0 z-50">
          <EventDateTimePicker
            selectedDate={eventDate}
            onSelect={(data) => setEventDate(data)}
            onClose={closePicker}
          />
        </div>
      )}
    </div>
  );
};

export default Home;

function GlassFieldDropdown({
  label,
  options = [],
  selected,
  setSelected,
  className = "",
  onClick,
  value,
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${className}`}
      onClick={onClick}
    >
      <p className="text-[14px] md:text-[24px] font-creto font-bold text-white cursor-pointer">
        {label}
      </p>

      <div className="relative w-full">
        {options.length > 0 ? (
          <>
            {/* SELECT */}
            <select
              value={selected || ""}
              onChange={(e) => setSelected?.(e.target.value)}
              className="
                w-full bg-transparent text-white
                px-3 py-2 pr-10
                text-[14px] text-center
                md:text-[16px] font-creto font-normal
                cursor-pointer
                appearance-none outline-none border-none
                focus:ring-0
              "
            >
              <option value="" disabled>
                Select an option
              </option>

              {options.map((option, index) => (
                <option
                  key={index}
                  value={option.value || option}
                  className="text-black"
                >
                  {option.label || option}
                </option>
              ))}
            </select>

            {/* 🔥 ARROW OVERLAY (THIS IS THE FIX) */}
            <div
              className="
                absolute right-3 top-1/2 -translate-y-1/2
                pointer-events-none
              "
            >
              <BiDownArrow className="text-white" />
            </div>
          </>
        ) : (
          <input
            value={value || ""}
            readOnly
            className="
              w-full bg-transparent text-white
              px-3 py-2 text-[14px]
              md:text-[16px] font-creto font-normal text-center
              cursor-pointer
              outline-none border-none
            "
          />
        )}
      </div>
    </div>
  );
}
